export const doubleJsonStr = (obj: Record<string, unknown>) =>
  JSON.stringify(JSON.stringify(obj));

export const joinValues = <T>(values: T[], separator?: string) =>
  values.filter(Boolean).join(separator ?? '');
